import { render, staticRenderFns } from "./AiAppSetting.vue?vue&type=template&id=8ef13d7a&scoped=true"
import script from "./AiAppSetting.vue?vue&type=script&lang=js"
export * from "./AiAppSetting.vue?vue&type=script&lang=js"
import style0 from "./AiAppSetting.vue?vue&type=style&index=0&id=8ef13d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef13d7a",
  null
  
)

export default component.exports